/**
 * 聊天推送配置
 */
import request from "@/utils/request";

// 获取聊天列表
function getWorkBotChatList(params:any) {
    return request.get('/api/v2/workbotChat/list', { params });
}

// 创建聊天参数
interface WorkBotChatListRequestParams {
    /// 分组ID
    cateId?: number | null;
    /// 分组路径
    catePath?: null | string;
    /// 创建时间
    createdAt?: null | string;
    /// 群聊名称
    groupChatName?: null | string;
    /// ID
    id?: number | null;
    /// 更新时间
    updatedAt?: null | string;
}

// 创建聊天
function createWorkBotChat(params: WorkBotChatListRequestParams) {
    return request.post('/api/v2/workbotChat/insert', params);
}

// 删除聊天
function deleteWorkBotChat(id: number) {
    return request.delete(`/api/v2/workbotChat/${id}`);
}


// 获取聊天报警列表
function getWorkBotAlarmList(params:any){
    return request.get(`/api/v2/workbotAlarm/list`, { params });
}

//删除告警
function deleteWorkBotAlarm(id: number|string) {
    return request.delete(`/api/v2/workbotAlarm/${id}`);
}

//批量删除告警
function deleteWorkBotAlarmBatch(id: number|string) {
    return request.delete(`/api/v2/workbotAlarm/batch/${id}`, );
}

/**
 * WorkbotAlarmQuery
 */
interface createWorkBotAlarmParams {
    /**
     * 报警类型 first填入alarmType second填入warningType
     */
    pairList: PairInteger[] | null;
    /**
     * 群聊ID
     */
    workbotChatId: number | null;

}

/**
 * Pair«Integer»
 */
interface PairInteger {
    first?: number | null;
    second?: number | null;
    
}

// WorkbotAlarm接口定义
export interface WorkbotAlarm {
    /**
     * 报警类型(ADAS DMS BSD)
     */
    alarmType?: number | null;
    /**
     * 创建时间
     */
    createdAt?: null | string;
    /**
     * ID
     */
    id?: number | null;
    /**
     * 更新时间
     */
    updatedAt?: null | string;
    /**
     * 报警类型
     */
    warningType?: number | null;
    /**
     * workbotChat  ID
     */
    workbotChatId?: number | null;
}

//新增告警
function createWorkBotAlarm(params: createWorkBotAlarmParams) {
    return request.post('/api/v2/workbotAlarm/insert', params);
}

export {
    getWorkBotChatList,
    createWorkBotChat,
    deleteWorkBotChat,
    getWorkBotAlarmList,
    deleteWorkBotAlarm,
    createWorkBotAlarm,
    deleteWorkBotAlarmBatch
}
export type {
    WorkBotChatListRequestParams,
    createWorkBotAlarmParams,
    PairInteger
}